import { useParams } from "react-router-dom";

import { usePageTitle } from "context/PageTitleContext";
import useGetStudentStaff from "hooks/useGetStudentStaff";

import styles from "./BookMeetingCalendar.module.css";

const BookMeetingCalendar = () => {
    usePageTitle("Book Meeting");
    const { canvasUserId } = useParams();
    const { studentStaff, isLoading, error } = useGetStudentStaff();

    const staffMemberCalendar = studentStaff?.find(
        (staff) => staff.canvasUserId === parseInt(canvasUserId),
    )?.calendlyBookingUrl;

    if (isLoading) return <p>Loading...</p>;
    if (error) return <p>Error: {error}</p>;
    if (!staffMemberCalendar)
        return <p>No calendar found for this staff member.</p>;

    return (
        <div className={styles.container}>
            <iframe src={staffMemberCalendar} className={styles.calendar} />
        </div>
    );
};

export default BookMeetingCalendar;
